import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    item_id: undefined | string,
    room_type_id: undefined | string,
    check_in_phone: undefined | string,
    check_in_user_name: undefined | string,
    handle_status: number | undefined,
    complaint_department_id: string | undefined,
    room_number: string | undefined,
    inDate: any,
    handleDate: any,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type project = {
    id: string
    item_name: string
}

type department = {
    "room_type_id": string,
    "room_type_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        check_in_user_name: undefined,
        check_in_phone: undefined,
        room_type_id: undefined,
        item_id: undefined,
        store_id: undefined,
        handle_status: undefined,
        complaint_department_id: undefined,
        room_number: undefined,
        inDate: null,
        handleDate: null,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 汇总数据
    const [summaryData, setSummaryData] = useState<any>([])
    const [summaryLoading, setSummaryLoading] = useState<boolean>(false)

    const [bmData, setBmData] = useState<department[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    // 权限数据获取
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (fetchOtherParams.inDate) {
            fetch({ pagination, fetchOtherParams })
        }

    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        if (fetchOtherParams.inDate || fetchOtherParams.date) {
            const p = { ...pagination }
            p.current = 1
            fetch({ pagination: p, fetchOtherParams })

        } else {
            message.error('必须选择入住日期')
        }
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        
        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        setSummaryLoading(true)

        // 清空汇总数据
        setSummaryData("")

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'inDate', ['current_check_in_start_day', 'current_check_in_end_day'])

        if (params.date) {
            params.check_in_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        axiosTable.get('/finance_center/business_report/check_in/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)

                // 设置汇总列表数据
                const { finance_report_summary } = response
                if (finance_report_summary && finance_report_summary.length) {
                    setSummaryData(finance_report_summary)
                }
            }

            setLoading(false)
            setSummaryLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    // 数据导出
    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.inDate) {
            params.current_check_in_start_day = params.inDate[0].format('YYYY-MM-DD')
            params.current_check_in_end_day = params.inDate[1].format('YYYY-MM-DD')
            delete params.inDate
        }

        if (params.date) {
            params.check_in_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        baseAxiosComplete('/finance_center/business_report/check_in/excel', {
            params: {
                ...iPagination,
                ...params

            }
        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    // 封账
    const confirmBill = () => {
        setLoading(true)
        setSummaryLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.inDate) {
            params.current_check_in_start_day = params.inDate[0].format('YYYY-MM-DD')
            params.current_check_in_end_day = params.inDate[1].format('YYYY-MM-DD')
            delete params.inDate
        }

        if (params.date) {
            params.check_in_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        baseAxiosComplete('/finance_center/business_report/check_in/confirm_bill', {
            params: {
                ...iPagination,
                ...params

            }
        }).then(res => {
            setLoading(false)
            setSummaryLoading(false)
        })
    }

    const [selectNameData, setSelectNameData] = useState<project[]>([])
    let bmOptions = bmData.map((el: any) => (<Option value={el.room_type_id} key={el.room_type_id}>{el.room_type_name}</Option>))
    let ItemNameOptions = selectNameData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

    return (<div className="common-page">
        {/* 财务中心 -> 经营报表 -> 入住经营报表 */}
        <BreadCrumb position={['财务中心', '入住经营报表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')

                        if (v) {
                            // 查询月子套餐
                            baseAxiosNoInfo('/global/item_list', {
                                params: {
                                    item_type: 3,
                                    store_id: v
                                }

                            }).then((res: any) => {
                                res && setSelectNameData(res)
                            })

                            // 查询房型
                            baseAxiosNoInfo('/global/room_type_list_by_store', {
                                params: {
                                    store_id: v
                                }
                            }).then((res: any) => {
                                res && setBmData(res)
                            })

                        } else {
                            setSelectNameData([])
                            setBmData([])
                        }
                    }} />
                </div>
                <Select
                    className="fl"
                    virtual={false}
                    placeholder="套餐"
                    style={{ marginRight: 8, marginBottom: 12, width: 240 }}
                    value={fetchOtherParams.item_id}
                    onChange={(v: string) => { handleChange(v, 'item_id') }}
                >
                    {ItemNameOptions}
                </Select>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户手机号码" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <Select
                    className="fl"
                    virtual={false}
                    placeholder="房型"
                    style={{ marginRight: 8, marginBottom: 12, width: 140 }}
                    value={fetchOtherParams.room_type_id}
                    onChange={(v: any) => { handleChange(v, 'room_type_id') }}
                >
                    {bmOptions}
                </Select>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="入住房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: '280px' }} className="fl" placeholder={["入住开始日期", "入住结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
                {permission.includes('封账') && <DatePicker style={{ marginRight: 8, marginBottom: 12, width: '140px' }} className="fl" placeholder={'入住日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />}
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('封账') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { confirmBill() }} type="dashed" >封账</Button>}
                {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="客户姓名" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="手机号码" dataIndex="check_in_phone" key="check_in_phone" />
                <Column title="房型" dataIndex="room_type_name" key="room_type_name" />
                <Column title="房间号" dataIndex="room_number" key="room_number" />
                <Column title="查询条件内入住天数" dataIndex="query_check_in_days" key="query_check_in_days" />
                <Column title="签单套餐" dataIndex="item_name" key="item_name" />
                <Column title="护理模式" dataIndex="nursing_care_type_desc" key="nursing_care_type_desc" />
                <Column title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="入住天数" dataIndex="agreement_days" key="agreement_days" />
                <Column title="在住时间段" dataIndex="current_room_check_in_day_range" key="current_room_check_in_day_range" />
                <Column title="入住时间" dataIndex="global_check_in_start_date" key="global_check_in_start_date" />
                <Column title="出所时间" dataIndex="global_check_in_end_date" key="global_check_in_end_date" />
                <Column title="入住金额" dataIndex="check_in_amount" key="check_in_amount" />
                <Column title="间天金额" dataIndex="split_day_amount" key="split_day_amount" />
            </Table>
        </div>

        {/* 汇总数据 */}
        <div className="common-main">
            <h3>汇总</h3>
            <Table loading={summaryLoading} dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="入住人数" dataIndex="check_in_num" key="check_in_num" />
                <Column title="查询条件内入住天数" dataIndex="query_check_in_days" key="query_check_in_days" />
                <Column title="合同总金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="入住总天数" dataIndex="agreement_days" key="agreement_days" />
                <Column title="入住总金额" dataIndex="check_in_amount" key="check_in_amount" />
                <Column title="间天总金额" dataIndex="split_day_amount" key="split_day_amount" />
            </Table>
        </div>
    </div>)
}